import { observable, action } from "mobx";

/**
* Market defines model for market of event
* @typedef Market
* @type {Object}
* @property {eventId} ID of the event, market belongs to
* @property {id} ID of the market
* @property {typeId} ID of the type of the market
* @property {lineGroupId} ID of the market group, market is a part of
* @property {name} Name of the market
* @property {selectionIds} List of selection IDs, stored as an Array
* @property {isQA} Flag, informing whether the market is QA or not
*/

export type MarketType = {

    eventId: string;
    id: string;
    typeId: string;

    name: string;
    selectionIds: string[];
}

export class Market {

    eventId: string;
    id: string;
    typeId: string;

    name: string;
    @observable selectionIds: string[];

    constructor(marketData: MarketType) {
        this.eventId = marketData.eventId;
        this.id = marketData.id;
        this.typeId = marketData.typeId;
        this.name = marketData.name;
        this.selectionIds = marketData.selectionIds;
    }

    @action updateSelections = (newSelections: string[]) => {
        this.selectionIds = newSelections;
    }
}